import _JSON$stringify from '/app/node_modules/babel-runtime/core-js/json/stringify';
import jsCookies from 'js-cookie';
import Cookies from 'cookies';
import { Buffer } from 'browser-buffer';
import { Store } from 'vuex';

export default (function (_ref, inject) {
    var req = _ref.req,
        res = _ref.res;

    var COOKIE = new Buffer('affiliation').toString('base64').replace(/=/g, '');
    Store.prototype.$setAuthCookie = function (value) {
        // console.log(value)
        if (!value) throw new Error('no se pudo generar la cookie de autenticación');

        var json = _JSON$stringify(value) + '|' + Date.now();
        var encodedText = new Buffer(json).toString('base64');
        jsCookies.set(COOKIE, encodedText);
    };

    Store.prototype.$removeAuthCookie = function () {
        if (process.server) {
            if (res.headersSent) return;
            new Cookies(req, res).set(COOKIE, '', { expires: new Date(1) });
        } else jsCookies.remove(COOKIE);
    };

    Store.prototype.$readAuthCookie = function () {
        var cookieValue = void 0;

        if (process.server) cookieValue = new Cookies(req, res).get(COOKIE);else cookieValue = jsCookies.get(COOKIE);

        if (!cookieValue) return null;

        var decodedText = new Buffer(cookieValue, 'base64').toString('ascii');
        var parts = decodedText.split('|');
        var parsedValue = parts.length ? JSON.parse(parts[0]) : {};
        // console.log('readAuthCookie', parsedValue)
        return parsedValue;
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/plugins/auth-cookie.js
// module id = ./src/plugins/auth-cookie.js
// module chunks = 34